import { defaultState } from './state'

import { SET, EMPTY, LOAD, LOADING, RESET } from './mutation-types'

export default {
  [SET](state, data) {
    for (let field in data) {
      if (field in data && field in state) {
        state[field] = data[field]
      }
    }
  },
  [LOADING](state, bool) {
    state.loading = bool
  },
  [LOAD](state, threats) {
    state.threats = threats || []
  },
  [EMPTY](state) {
    state.threats = []
  },
  [RESET](state) {
    Object.assign(state, defaultState())
  },
}
